/* Dropdayz — sneaker request page: staggered form reveal.

   Same progressive-enhancement contract as ddz-motion.js:
   - the hidden state lives under .ddz-req-motion, which only this script
     adds — so without JS, or with reduced-motion, nothing is ever hidden;
   - snap-hide: transitions are suppressed for one frame while the hidden
     state is applied, so there is no visible fade-out after first paint;
   - a safety timeout reveals everything after 5s no matter what — a form
     that stays invisible would be the worst possible failure here. */
(function () {
  if (!('IntersectionObserver' in window)) { return; }
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }

  var form = document.getElementById('ddz-request-form');
  if (!form) { return; }
  var items = Array.prototype.slice.call(form.querySelectorAll('.ddz-form__field, .ddz-form__submit'));
  if (!items.length) { return; }

  /* snap-hide: kill transitions for one frame while the gate class lands */
  items.forEach(function (el, i) {
    el.style.transition = 'none';
    el.style.setProperty('--ddz-req-d', (i * 70) + 'ms');
  });
  form.closest('.ddz-auth__section').classList.add('ddz-req-motion');
  void form.offsetWidth;
  requestAnimationFrame(function () {
    items.forEach(function (el) { el.style.transition = ''; });
  });

  var revealed = false;
  function reveal(){
    if (revealed) { return; }
    revealed = true;
    items.forEach(function (el) { el.classList.add('is-in'); });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { reveal(); io.disconnect(); }
    });
  }, { threshold: 0.15 });
  io.observe(form);

  /* safety net: the form must never stay invisible */
  setTimeout(reveal, 5000);
})();
